<script>
import SimulatorStudentDetailSectionComponent from '../features/SimulatorStudentDetailSectionComponent';
import SimulatorStudentDetailQuestionView from './SimulatorStudentDetailQuestionView';

export default {
  name: 'SimulatorStudentDetailSectionView',
  components: {
    'simulator-detail-question-view': SimulatorStudentDetailQuestionView,
  },
  extends: SimulatorStudentDetailSectionComponent,
};
</script>
<template>
  <div
    v-loading="isLoading"
    class="sim_apply_panel"
  >
    <div class="sim_apply_panel_head">
      <div class="sim_apply_panel_icon">
        <i class="uil uil-layer-group" />
      </div>
      <div class="sim_apply_panel_text">
        <h4 class="sim_apply_panel_title">
          {{ currentSection.name }}
        </h4>
        <p
          v-if="currentSection.description"
          class="sim_apply_panel_subtitle"
        >
          {{ currentSection.description }}
        </p>
      </div>
    </div>

    <template v-if="questionSelected">
      <simulator-detail-question-view
        :simulator-id="simulatorId"
        :current-question="questionSelected"
      />

      <div class="sim_apply_nav">
        <button
          type="button"
          class="sim_apply_nav_btn"
          @click="onPrevQuestion"
        >
          <i class="uil uil-angle-left" />
          <span>Anterior</span>
        </button>

        <button
          v-if="!isFinalQuestion()"
          type="button"
          class="account_btn_primary"
          @click="onNextQuestion"
        >
          <span>Siguiente</span>
          <i class="uil uil-angle-right" />
        </button>
        <button
          v-else
          type="button"
          class="account_btn_primary"
          @click="onFinishSection"
        >
          <span>Finalizar sección</span>
          <i class="uil uil-check-circle" />
        </button>
      </div>
    </template>
  </div>
</template>
